
module.exports = {
    links: [],
}